'use client';

import { Modal } from "react-bootstrap";
import classes from "./login_modal.module.css";
import { useContext } from "react";
import AuthContext from "@/providers/auth-context";
import LoginModalLogin from "./login_modal_login";
import LoginModalRegistration from "./login_modal_registration";
import RecaptchaWrapper from "../recaptcha/recaptcha_wrapper";
import { usePathname } from "next/navigation";
import { isRecaptchaPage } from "@/functions/is_recaptcha_page";

export default function LoginModal() {
    const {showLogin, setShowLogin, showLoginState, setRedirectURL, loginIsProvider} = useContext(AuthContext);

    let content = <div className={`${classes["modal-main-content"]} ${(loginIsProvider && showLoginState !== "login") ? classes["provider"] : ""}`}>
        {showLoginState === "login" 
            ? <LoginModalLogin />
            : <LoginModalRegistration />
        }
    </div>

    return <Modal show={showLogin} onHide={() => {setShowLogin(false); setRedirectURL("");}} className={`${classes.modal} p-0`} dialogClassName={`${classes["modal-dialog"]} ${loginIsProvider ? classes["provider"] : ""}`} contentClassName={`${classes["modal-content"]}`}>
        {showLogin && <RecaptchaWrapper>
            {content}
        </RecaptchaWrapper>}
    </Modal>
}
